(() => {
  const SELECTOR = '[data-jc-learn-vertical-carousel]';
  const DURATION = 540;

  const numberLabel = (value, total) => `${String(value + 1).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;

  const initCarousel = (root) => {
    if (root.dataset.jcLearnVerticalReady === 'true') return;

    const viewport = root.querySelector('[data-jc-learn-carousel-viewport]');
    const stage = root.querySelector('[data-jc-learn-carousel-stage]');
    const slides = [...root.querySelectorAll('[data-jc-learn-carousel-slide]')];
    const previousButton = root.querySelector('[data-jc-learn-carousel-prev]');
    const nextButton = root.querySelector('[data-jc-learn-carousel-next]');
    const progress = root.querySelector('[data-jc-learn-carousel-progress]');
    const liveRegion = root.querySelector('[data-jc-learn-carousel-live]');

    if (!viewport || !stage || slides.length < 1) return;

    root.dataset.jcLearnVerticalReady = 'true';

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let isAnimating = false;
    let pointerStart = null;

    const updateStatus = () => {
      const activeSlide = slides[activeIndex];
      if (progress) progress.textContent = numberLabel(activeIndex, slides.length);
      if (liveRegion) liveRegion.textContent = `Learn guide ${activeIndex + 1} of ${slides.length}${activeSlide?.querySelector('.jc-learn-vertical-carousel__heading')?.textContent ? `: ${activeSlide.querySelector('.jc-learn-vertical-carousel__heading').textContent.trim()}` : ''}`;
    };

    const updateStageHeight = () => {
      const activeSlide = slides[activeIndex];
      if (!activeSlide) return;
      stage.style.height = `${Math.ceil(activeSlide.getBoundingClientRect().height)}px`;
    };

    const switchTo = (requestedIndex, direction = 'next') => {
      if (isAnimating || requestedIndex === activeIndex || !slides[requestedIndex]) return;

      isAnimating = true;
      const outgoing = slides[activeIndex];
      const incoming = slides[requestedIndex];
      const enterClass = direction === 'next' ? 'is-entering-down' : 'is-entering-up';
      const exitClass = direction === 'next' ? 'is-exiting-up' : 'is-exiting-down';

      incoming.classList.add('is-active', enterClass);
      incoming.setAttribute('aria-hidden', 'false');
      outgoing.classList.add('is-leaving', exitClass);

      activeIndex = requestedIndex;
      updateStageHeight();
      updateStatus();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          incoming.classList.remove(enterClass);
        });
      });

      window.setTimeout(() => {
        outgoing.classList.remove('is-active', 'is-leaving', exitClass);
        outgoing.setAttribute('aria-hidden', 'true');
        updateStageHeight();
        isAnimating = false;
      }, DURATION);
    };

    const move = (direction) => {
      if (slides.length < 2) return;
      const nextIndex = direction === 'next'
        ? (activeIndex + 1) % slides.length
        : (activeIndex - 1 + slides.length) % slides.length;
      switchTo(nextIndex, direction);
    };

    slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
    });
    updateStatus();

    requestAnimationFrame(updateStageHeight);
    window.addEventListener('resize', () => window.requestAnimationFrame(updateStageHeight), { passive: true });
    window.addEventListener('load', () => window.requestAnimationFrame(updateStageHeight), { once: true });

    previousButton?.addEventListener('click', () => move('previous'));
    nextButton?.addEventListener('click', () => move('next'));

    viewport.addEventListener('keydown', (event) => {
      if (['ArrowDown', 'PageDown'].includes(event.key)) {
        event.preventDefault();
        move('next');
      } else if (['ArrowUp', 'PageUp'].includes(event.key)) {
        event.preventDefault();
        move('previous');
      } else if (event.key === 'Home') {
        event.preventDefault();
        switchTo(0, 'previous');
      } else if (event.key === 'End') {
        event.preventDefault();
        switchTo(slides.length - 1, 'next');
      }
    });

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
      viewport.setPointerCapture?.(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!pointerStart || event.pointerId !== pointerStart.id) return;
      const deltaY = event.clientY - pointerStart.y;
      const deltaX = event.clientX - pointerStart.x;
      if (Math.abs(deltaY) > 8 && Math.abs(deltaY) > Math.abs(deltaX)) event.preventDefault();
    });

    const completePointer = (event) => {
      if (!pointerStart || event.pointerId !== pointerStart.id) return;
      const deltaY = event.clientY - pointerStart.y;
      const deltaX = event.clientX - pointerStart.x;
      pointerStart = null;
      if (Math.abs(deltaY) > 48 && Math.abs(deltaY) > Math.abs(deltaX)) {
        move(deltaY < 0 ? 'next' : 'previous');
      }
    };

    viewport.addEventListener('pointerup', completePointer);
    viewport.addEventListener('pointercancel', () => { pointerStart = null; });
  };

  const init = () => document.querySelectorAll(SELECTOR).forEach(initCarousel);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.(SELECTOR).forEach(initCarousel);
  });
})();
